import { Component, inject } from '@angular/core';
import { MetadataService, Order } from 'gung-standard';
import { JeevesOrderDetailsComponent } from 'gung-standard-jeeves';

@Component({
    selector: 'car-liner-order-details',
    templateUrl: './car-liner-order-details.component.html',
    styleUrls: ['./car-liner-order-details.component.scss'],
    standalone: false
})
export class CarLinerOrderDetailsComponent extends JeevesOrderDetailsComponent {
  private metadataService = inject(MetadataService);

  getStatusTag(orderStatus: number): string {
    if (orderStatus < 13) {
      return this.translateService.instant('ENTRY_IN_PROGRESS');
    } else if (orderStatus === 13) {
      return this.translateService.instant('ENTERED');
    } else if (orderStatus >= 14 && orderStatus <= 50) {
      return this.translateService.instant('PICKING_IN_PROGRESS');
    } else if (orderStatus === 70) {
      return this.translateService.instant('INVOICED');
    }
    return 'UNDEFINED';
  }

  public isOrderEditable = (order: Order, isSales: boolean) => {
    return false;
  }

  getCountry(countryCode: string): string {
    if (countryCode == null) return '';
    return this.metadataService.getMetadataValue('xr', 'land', countryCode.toUpperCase());
  }

  override buildStandardOrderRowsSummaryTable(): void {
    super.buildStandardOrderRowsSummaryTable();

    const productIdsToRemove: string[] = [];

    for (const summary of this.standardOrderedProductsSummary) {
      if (this.products[summary.rowId]?.extra?.ar?.lagtyp === 9) {
        const sr = this.products[summary.rowId]?.extra?.sr;
        if (sr && Array.isArray(sr)) {
          for (const item of sr) {
            for (const summaryEntry of this.standardOrderedProductsSummary) {
              if (item.bartnrstrukt === summaryEntry.rowId) {
                productIdsToRemove.push(item.bartnrstrukt);
              }
            }
          }
        }
      }
    }

    this.standardOrderedProductsSummary = this.standardOrderedProductsSummary.filter(
      summary => !productIdsToRemove.includes(summary.rowId)
    );

    for (const orderRow of this.order.rows) {
      if (productIdsToRemove.includes(orderRow.id)) {
        orderRow.extra._gungHideRow = true;
      }
    }

    this.hasDiscount = this.standardOrderedProductsSummary.some(
      p => p.rows?.[0]?.extra?.gme?.discountPercentage
    );

    this.hasExternalReference = this.standardOrderedProductsSummary.some(
      p => p.rows?.[0]?.extra?.gme?.externalReference?.trim()
    );

    this.isDataReady = true;
  }
}
